module.exports = __webpack_public_path__ + "img/adori-ai.f13d92e9.svg";